import type { TitledItem } from './TitledListSection';
import { TitledListSection } from './TitledListSection';
import {
  useRorosUsps,
  useRorosUspCreate,
  useRorosUspUpdate,
  useRorosUspRemove,
  useRorosUspReorder,
} from '@/hooks/roros/overarching';
import type { RorosUspDTO } from '@/types/roros/overarching';
import { t } from '@/lib/i18n';

export function UspsSection() {
  const q = useRorosUsps({ pageSize: '100' });
  const items = ((q.data as unknown) ?? []) as RorosUspDTO[];
  return (
    <TitledListSection<RorosUspDTO>
      title={t('USPs')}
      emptyHint={t('No USPs yet.')}
      items={items}
      useCreate={useRorosUspCreate}
      useUpdate={useRorosUspUpdate}
      useRemove={useRorosUspRemove}
      useReorder={useRorosUspReorder}
    />
  );
}
